/**
 * Public showcase records mirrored from the ATK AppsHub catalogue (atkapps.com).
 * Keep titles, summaries and statuses in sync with the hub. No secrets here.
 */
export const APPS_HUB_URL = "https://atkapps.com";

export type GraphicKey =
  | "focus-scheduler"
  | "ai-date-planner"
  | "data-sync"
  | "grocery-management"
  | "cnmi-legal-aide"
  | "learn"
  | "guides"
  | "hub";

export type ShowcaseApp = {
  slug: string;
  title: string;
  summary: string;
  category: string;
  access: string[];
  graphic_key: GraphicKey;
};

export const SHOWCASE_APPS: ShowcaseApp[] = [
  { slug: "focus-scheduler", title: "Focus Scheduler", summary: "Turn tasks and deadlines into a plan that fits your calendar.", category: "Work", access: ["Google Sheets", "Telegram"], graphic_key: "focus-scheduler" },
  { slug: "ai-date-planner", title: "AI Date Planner", summary: "Plan trips, holidays, dates and hangouts around what you enjoy.", category: "Everyday life", access: ["Web app", "Telegram"], graphic_key: "ai-date-planner" },
  { slug: "data-sync", title: "ATK Data Sync", summary: "Keep information moving between your Google Sheets.", category: "Work", access: ["Google Sheets"], graphic_key: "data-sync" },
  { slug: "grocery-management", title: "Grocery Management Tool", summary: "Keep track of what's at home and what needs buying.", category: "Household", access: ["Google Sheets"], graphic_key: "grocery-management" },
  { slug: "cnmi-legal-aide", title: "CNMI Legal AIDE", summary: "Find and explore public CNMI legal sources in one place.", category: "Research", access: ["Web app"], graphic_key: "cnmi-legal-aide" },
];

export const appUrl = (slug: string) => `${APPS_HUB_URL}/tools/${slug}`;
